<template>
  <div class="footer">
    <div class="container">
      <div class="columns is-mobile">
        <!-- column left -->
        <div v-if="window.width > 1023" class="has-text-left column">
          <p>
            <img class="icon-logo" src="~@/assets/img/public_logo.png" /><span
              >sondage</span
            >
          </p>
        </div>
        <!-- column centered -->
        <div v-if="window.width > 1023" class="has-text-right column">
          {{ myfooter }}
        </div>
        <div class="has-text-left column">
          <a
            style="color:#fff"
            href="https://colidee.com/mentions_legales.htm"
            >Ⓒ2021 - {{ $t("sondage.mentions-legales") }}</a
          >
        </div>
        <!-- column right -->
        <div class="column">
          <div class="has-text-right">
            <img
              @click="choosenLanguageFunction('fr')"
              class="icon-flag"
              src="~@/assets/img/flag_translation/fr-2.png"
            />
            <img
              @click="choosenLanguageFunction('en')"
              class="icon-flag"
              src="~@/assets/img/flag_translation/en-2.png"
            />
            <img
              @click="choosenLanguageFunction('es')"
              class="icon-flag"
              src="~@/assets/img/flag_translation/es-2.png"
            />
            <img
              @click="choosenLanguageFunction('de')"
              class="icon-flag"
              src="~@/assets/img/flag_translation/de-2.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      myfooter: process.env.FOOTER
    }
  },
  props: {
    window: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['arrayLanguagesUpdated'])
  },
  methods: {
    choosenLanguageFunction (value) {
      var selectlangue = value
      this.$i18n.locale = value
      this.$store.dispatch('changeLangue', selectlangue)
      this.$store.commit('UPDATE_CHOOSEN_LANGUAGE_CLIENT', selectlangue)
    }
  }
}
</script>

<style scoped>
#selectlangue {
  width: 58px;
  padding: 5px;
  font-size: 16px;
  line-height: 1;
  border: 0;
  border-radius: 5px;
  height: 34px;
  background: url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='18' height='18' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='white'/></g></svg>")
    no-repeat;
  background-position: right 5px top 50%;
  -webkit-appearance: none;
}
.footer {
  padding: 2px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #424a60;
  color: white;
  font-size: 12px;
  height: 35px;
  line-height: 25px;
  width: 100%;
}
.locale-changer {
  position: absolute;
  right: 5px;
  top: 1px;
}
.select {
  border-radius: 0px;
}
.icon-flag {
  vertical-align: middle;
  height: 15px;
  width: 20px;
  margin-right: 8px;
  cursor: pointer;
}
.icon-logo {
  vertical-align: middle;
  height: 18px;
  width: auto;
}
.control {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/MyFooter.vue